export const addGtmScripts = (key: string) => {
  if (!document.querySelector(`script[src*="www.googletagmanager.com/gtm.js?id=${key}"]`)) {
    const gtmScript = document.createElement('script');
    const gtmNoscript = document.createElement('noscript');

    gtmScript.innerHTML = `
      (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', '${key}');
    `;

    gtmNoscript.innerHTML = `
          <iframe src="https://www.googletagmanager.com/ns.html?id=${key}"
                  height="0" width="0" style="display:none;visibility:hidden"></iframe>
        `;

    document.head.appendChild(gtmScript);
    document.body.appendChild(gtmNoscript);

    window.dispatchEvent(new Event('gtmLoaded'));
  }
};
